import { CustomAction, UserState, ListView } from '../model/state';
import { FETCH_USER_LIST_SUCCESS, FETCH_USER_SUCCESS, FETCH_USER, FETCH_USER_ERROR, CLEAR_CURRENT_USER, UPDATE_USER_SEARCH, REMOVE_USER_SUCCESS } from 'constants/ActionTypes';
import { UserPayload } from 'actions/User';
import { User } from 'model';

const initialState: UserState = {
  notFiltered: {
    rows: [],
    total: 0,
    page: 1
  },
  list: {
    rows: [],
    total: 0,
    page: 1
  },
  current: {
    data: {
      email: '',
      firstName: '',
      lastName: ''
    },
    isLoading: false,
  },
  search: '',
};

function applySearchFilter(search: string, state: UserState): ListView<User> {
  const searchKey = search.toLowerCase();
  const list = state.notFiltered.rows?.filter(user => {
    return  `${user.firstName} ${user.lastName}`.toLowerCase().includes(searchKey) ||
            user.email.toLowerCase().includes(searchKey)
  });
  return {
    rows: list || [],
    total: list?.length || 0,
    page: 1
  }
}

function userReducer(state: UserState | undefined = initialState, action: CustomAction<UserPayload>) {
  switch (action.type) {

    case FETCH_USER_LIST_SUCCESS:
      const list = {
        rows: action.payload?.users,
        total: action.payload?.users?.length,
        page: 1
      };
      return {
        ...state,
        list: { ...list },
        notFiltered: { ...list },
        search: '',
      }

    case FETCH_USER:
      return { ...state, current: { ...state.current, isLoading: true } }

    case FETCH_USER_SUCCESS: {
      let user: User;
      if (action.payload?.user) {
        user = {
          ...action.payload?.user,
          locationRoles: action.payload?.user?.locationRoles || []
        }
      } else {
        user = initialState.current.data
      }

      return {
        ...state,
        current: {
          ...state.current,
          data: action.payload?.user ? user : initialState.current.data,
          isLoading: false
        }
      }
    }

    case UPDATE_USER_SEARCH:
      return {
        ...state,
        search: action.payload?.search || '',
        list: applySearchFilter(action.payload?.search || '', state)
      }

    case FETCH_USER_ERROR:
      return { ...state, current: { ...state.current, isLoading: false } }

    case CLEAR_CURRENT_USER:
      return { ...state, current: initialState.current }

    case REMOVE_USER_SUCCESS:
      const userId = action.payload?.userId;
      const index = state.notFiltered.rows?.findIndex((user: User) => user.id === userId);
      if (index === undefined) {
        return { ...state };
      }

      const notFiltered = {
        rows: [
          ...state.notFiltered.rows?.slice(0, index) || [],
          ...state.notFiltered.rows?.slice(index + 1) || [],
        ],
        total: (state.notFiltered.rows || []).length - 1,
        page: 1
      }

      const indexList = state.list.rows?.findIndex((user: User) => user.id === userId);
      if (indexList === undefined) {
        return { ...state, notFiltered };
      }

      const filteredList = {
        rows: [
          ...state.list.rows?.slice(0, indexList) || [],
          ...state.list.rows?.slice(indexList + 1) || [],
        ],
        total: (state.list.rows || []).length - 1,
        page: 1
      }

      return { ...state, notFiltered, list: filteredList };

    default:
      return state
  }
}

export default userReducer;
